module.exports = __webpack_public_path__ + "static/media/ico-arrow.38f75f97.svg";